// Configuração de integração do CRM com n8n + Evolution API.
//
// O envio de mensagens (inbox e campanhas) é feito chamando webhooks do n8n,
// que por sua vez falam com a Evolution API. Configure as URLs via variáveis
// de ambiente (.env) — VITE_* fica exposto no client, então use webhooks
// protegidos por token/secret no n8n.
//
// Exemplo de .env:
//   VITE_N8N_WEBHOOK_ENVIAR_MENSAGEM=https://n8n.seudominio.com/webhook/sunpro-enviar
//   VITE_N8N_WEBHOOK_CAMPANHA=https://n8n.seudominio.com/webhook/sunpro-campanha
//   VITE_N8N_WEBHOOK_TOKEN=algum-token-secreto

const env = import.meta.env as Record<string, string | undefined>;

export const crmConfig = {
  /** Webhook n8n que envia uma mensagem avulsa (inbox). */
  webhookEnviarMensagem: env.VITE_N8N_WEBHOOK_ENVIAR_MENSAGEM ?? "",
  /** Webhook n8n que dispara uma campanha (lista de distribuição). */
  webhookCampanha: env.VITE_N8N_WEBHOOK_CAMPANHA ?? "",
  /** Token enviado no header Authorization para autenticar no n8n. */
  webhookToken: env.VITE_N8N_WEBHOOK_TOKEN ?? "",
};

export function crmWebhookHeaders(): HeadersInit {
  const headers: HeadersInit = { "Content-Type": "application/json" };
  if (crmConfig.webhookToken) {
    headers["Authorization"] = `Bearer ${crmConfig.webhookToken}`;
  }
  return headers;
}
